import React from "react";
import VisaSmallIcon from "../icons/VisaSmallIcon";
import AmExSmallIcon from "../icons/AmExSmallIcon";
import DiscoverSmallIcon from "../icons/DiscoverSmallIcon";
import MasterCardSmallIcon from "../icons/MasterCardSmallIcon";
import GenericSmallIcon from "../icons/GenericSmallIcon";
import VisaLargeIcon from "../icons/VisaLargeIcon";
import AmExLargeIcon from "../icons/AmExLargeIcon";
import DiscoverLargeIcon from "../icons/DiscoverLargeIcon";
import MasterCardLargeIcon from "../icons/MasterCardLargeIcon";
import GenericCardLarge from "../icons/GenericCardLarge";

const cardBrands = {
  visa: { label: "Visa", small: VisaSmallIcon, large: VisaLargeIcon },
  master_card: {
    label: "Mastercard",
    small: MasterCardSmallIcon,
    large: MasterCardLargeIcon
  },
  discover: {
    label: "Discover",
    small: DiscoverSmallIcon,
    large: DiscoverLargeIcon
  },
  amex: {
    label: "American Express",
    small: AmExSmallIcon,
    large: AmExLargeIcon
  },
  default: {
    label: "Credit card",
    small: GenericSmallIcon,
    large: GenericCardLarge
  }
};

const normalizeType = type => {
  if (!type) return undefined;
  const lower = type.toLowerCase();
  if (lower === "mastercard") return "master_card";
  return lower;
};

const CardType = ({ type, size = "small" }) => {
  const normalizedType = normalizeType(type);
  const { label, [size]: IconComponent } =
    cardBrands[normalizedType] || cardBrands.default;
  return <IconComponent />;
};

export default CardType;
